module.exports = __webpack_public_path__ + "img/feature1-2x.519b1f3.png";